'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _acknowledgements = require('./acknowledgements');

var _acknowledgements2 = _interopRequireDefault(_acknowledgements);

var _contactInformation = require('./contactInformation');

var _contactInformation2 = _interopRequireDefault(_contactInformation);

var _flightDetails = require('./flightDetails');

var _flightDetails2 = _interopRequireDefault(_flightDetails);

var _flightInformation = require('./flightInformation');

var _flightInformation2 = _interopRequireDefault(_flightInformation);

var _medicalInformation = require('./medicalInformation');

var _medicalInformation2 = _interopRequireDefault(_medicalInformation);

var _travelReady = require('./travelReady');

var _travelReady2 = _interopRequireDefault(_travelReady);

var _passportInformation = require('./passportInformation');

var _passportInformation2 = _interopRequireDefault(_passportInformation);

var _personalInformation = require('./personalInformation');

var _personalInformation2 = _interopRequireDefault(_personalInformation);

var _travelDocuments = require('./travelDocuments');

var _travelDocuments2 = _interopRequireDefault(_travelDocuments);

var _waiver = require('./waiver');

var _waiver2 = _interopRequireDefault(_waiver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formOverrides = {
    acknowledgements: _acknowledgements2.default,
    transferAcknowledgements: _acknowledgements.transferAcknowledgements,
    contactInformation: _contactInformation2.default,
    flightDetails: _flightDetails2.default,
    flightInformation: _flightInformation2.default,
    medicalInformation: _medicalInformation2.default,
    travelReady: _travelReady2.default,
    passportInformation: _passportInformation2.default,
    personalInformation: _personalInformation2.default,
    travelDocuments: _travelDocuments2.default,
    waiver: _waiver2.default
}; /**
   *  Point of contact for override input option labels
   *
   *  ie: import { flightDetails } from 'metadata/formOverrides';
   *
   *  Labels are in MessageDescriptorMap format for react-intl:
   *
   *    type MessageDescriptor = {
   *        id: string,
   *        defaultMessage: string,
   *        description?: string,
   *    };
   *
   *    type MessageDescriptorMap = {[key: string]: MessageDescriptor};)
   */

exports.default = formOverrides;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOverrides/index.js
// module id = 1383
// module chunks = 0